/* pokelix-fx.js — Foil & Ink interaction layer
   Announcement countdown, 3D tilt, add-to-cart pop. */
(function () {
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

/* --- Announcement bar countdown (Storm Emerald M6, 31.07.2026) --- */
var RELEASE = new Date('2026-07-31T00:00:00+02:00');
var isEN = document.documentElement.lang === 'en';
document.querySelectorAll('.announcement-bar__message').forEach(function (el) {
  if (!/storm emerald/i.test(el.textContent)) return;
  var days = Math.ceil((RELEASE - new Date()) / 864e5);
  if (days > 0 && !el.querySelector('.pokelix-countdown')) {
    var span = document.createElement('span');
    span.className = 'pokelix-countdown';
    span.textContent = isEN
      ? ' • ' + days + (days === 1 ? ' day left' : ' days left')
      : ' • noch ' + days + (days === 1 ? ' Tag' : ' Tage');
    (el.querySelector('span') || el).appendChild(span);
  }
});


  /* --- Add-to-cart pop --- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.product-form__submit, .quick-add__submit');
    if (!btn || reduceMotion) return;
    btn.classList.remove('pokelix-pop');
    void btn.offsetWidth; /* restart animation */
    btn.classList.add('pokelix-pop');
  });

  /* --- 3D tilt: hero image + first PDP media (fine pointers only) --- */
  if (reduceMotion || !window.matchMedia('(pointer: fine)').matches) return;

  function attachTilt(el, host, maxDeg) {
    host.addEventListener('pointermove', function (e) {
      var r = el.getBoundingClientRect();
      var x = (e.clientX - r.left) / r.width - 0.5;
      var y = (e.clientY - r.top) / r.height - 0.5;
      el.style.transform =
        'perspective(900px) rotateX(' + (-y * maxDeg).toFixed(2) + 'deg) rotateY(' + (x * maxDeg).toFixed(2) + 'deg)';
      el.style.willChange = 'transform';
    });
    host.addEventListener('pointerleave', function () {
      el.style.transform = '';
      el.style.willChange = '';
    });
  }

  document.querySelectorAll('.pokelix-hero__product-img').forEach(function (el) {
    attachTilt(el, el.closest('.pokelix-hero__image-wrap') || el, 9);
  });
  document.querySelectorAll('.product__media-item:first-child .product__media').forEach(function (el) {
    attachTilt(el, el, 6);
  });
})();
